import axios from "axios";
import { Config } from "../../../core/config/config";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/document/file`;

export const fileService = {
    async getProfileImageAsync() {
        return axios.get(`${GATEWAY_URL}/profile-image`)
        .then((response) => {
            return response.data;
        });
    },
}
